import React, { InputHTMLAttributes } from "react";

import { Icon } from "@cobasi/ds-icons";

export interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  placeholder?: string;
  type: string;
  value: string | number;
  customSize?: "sm" | "md" | "lg" | string;
  iconSize?: "left" | "right";
  icon?: any;
  variant?: string;
  fullWidth?: boolean;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
  className?: string;
}

const TextField: React.FC<TextFieldProps> = ({
  label,
  placeholder,
  type,
  value,
  customSize,
  iconSize,
  icon,
  variant = "",
  fullWidth,
  helperText,
  error,
  disabled,
  className,
  ...props
}) => {
  const hasSize = customSize ? ` input-field-${customSize}` : "";
  const hasVariant = variant && ` ${variant}`;
  const isError = error ? " error" : "";
  const isDisabled = disabled ? " disabled" : "";
  const hasClassName = className ? ` ${className}` : "";

  const inputClasses = `input-field${hasSize}${hasVariant}${isError}${isDisabled}${hasClassName}`;

  return (
    <div className={`input-container${fullWidth ? " full-width" : ""}`}>
      <div className={inputClasses}>
        {iconSize === "left" && icon && (
          <Icon icon={icon} width="1.6rem" height="1.6rem" />
        )}
        <input
          id="input"
          type={type}
          value={value}
          placeholder={placeholder ?? ""}
          disabled={disabled}
          {...props}
        />
        {label && <label htmlFor={props.id ?? "input"}>{label}</label>}
        {iconSize === "right" && icon && (
          <Icon icon={icon} width="1.6rem" height="1.6rem" />
        )}
      </div>
      {helperText && <div className="helper-text">{helperText}</div>}
    </div>
  );
};

export default TextField;
